module.exports = __webpack_public_path__ + "img/NBA_Foul.4d1f3d93.png";